var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment-form"},[_c('div',{staticClass:"form-row"},[_c('div',{attrs:{"id":'card-element-' + _vm._uid}}),_vm._v(" "),(_vm.error)?_c('div',{attrs:{"id":"card-errors","role":"alert"},domProps:{"textContent":_vm._s(_vm.error.message)}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }